import { Injectable, Inject, Output, EventEmitter  } from '@angular/core';
import { Headers, Http } from "@angular/http";
import { Router } from '@angular/router';
import 'rxjs/Rx';
import { DatosEnviar } from "../models/DatosEnviar";
//import { EventEmitter } from 'protractor';
//import{ AppConfig } from "../services/app.config"

//const data = require('../../assets/config/config.json');

@Injectable()
export class CscaeService {

    BaseUrl: string;

    /*
    @Output()
    TreeLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();
    */
    TreeLoading: number = 0;
    
    

    constructor(private http: Http, private router: Router,
        @Inject('BASE_URL') private baseUrl: string) {
        //console.log(window.location.href);

        //let url = window.location.href.split("/"); //PROTO
        //url.pop();
        //url.pop();
        //url.pop();
        //this.BaseUrl = "localhost:5001/api"; //PROTO
        //this.BaseUrl = AppConfig.settings.apiServer.url + "/api";
        //this.BaseUrl = data.BASE_URL + "/api";
        //console.log(this.BaseUrl);
        //console.log(url);

        //this.BaseUrl = "http://localhost:56682/api";

        this.BaseUrl = baseUrl + "/api";


    }

    GetEntidad(CodigoPrimario: string | null, CodigoSecundario: string | null) {
        this.TreeLoading += 1;
        let url = this.BaseUrl + "/webService/entidad/" + CodigoPrimario + "/" + CodigoSecundario;
        let headers = new Headers();
        return this.http.get(url)
        .map(res => {
            this.TreeLoading -= 1;
            return res.json();
        });
    }

    GetEntidadesHijas(CodigoPrimario: string | null, CodigoSecundario: string | null) {
        this.TreeLoading += 1;
        //console.log(this.TreeLoading);
        let url = this.BaseUrl + "/webService/entidadesHijas/" + CodigoPrimario + "/" + CodigoSecundario;
        let headers = new Headers();
        return this.http.get(url)
        .map(res => {
            
            this.TreeLoading -= 1;
            /*
            console.log(this.TreeLoading);

            if(this.TreeLoading == 0)
                this.TreeLoaded.emit(true);
                */

            return res.json();
        });
    }

    NuevosDatos(Datos: DatosEnviar) {
        let body = JSON.stringify(Datos);
        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        return this.http.post(this.BaseUrl, body, { headers })
            .map(res => {
                //console.log(res.json());
                return res.json();
            });
    }

    EditarDatos(Datos: DatosEnviar) {

		let headers = new Headers({
			'Content-Type': 'application/json'
        });

        let url = this.BaseUrl + "/DatosTablas/" + Datos.CodigoPrimario + "/" + Datos.CodigoSecundario + "/" + Datos.Ejercicio + "/" + Datos.Mes;
        
        let body = JSON.stringify(Datos.Datos);

        //console.log(body);


		return this.http.put(url, body, { headers })
			/*.map(res => {
				console.log(res.json());
                return res.json() || null;
			})*/; //PROTO
	}

    GetEjercicioMes(colegio: string | null, delegacion: string | null) {
        let url = this.BaseUrl + "/DatosTablas/" + colegio + "/" + delegacion;
        let headers = new Headers();
        return this.http.get(url)
            .map(res => res.json());
    }

    GetDatos(Colegio: string | null, Delegacion: string | null, Ejercicio: string, Mes: string) {
        let url = this.BaseUrl + "/DatosTablas/" + Colegio + "/" + Delegacion + "/" + Ejercicio + "/" + Mes;
		let headers = new Headers();
        return this.http.get(url)
            .map(res => res.json());
    }

    GetEstructura() {
        let url = this.BaseUrl + "/Estructura";
        let headers = new Headers();
        return this.http.get(url)
            .map(res => res.json());
    }

    GetDatosResumen(Colegio: string | null, Delegacion: string | null, Ejercicio: number) {
        let url = this.BaseUrl + "/DatosTablas/" + Colegio + "/" + Delegacion + "/" + Ejercicio;
        let headers = new Headers();
        return this.http.get(url)
            .map(res => res.json());
    }

    GetDatosVacios() {
        let url = this.BaseUrl + "/ TiposTablas";
        let headers = new Headers();
        return this.http.get(url)
            .map(res => res.json());
       
    }

}


// WEBPACK FOOTER //
// ./src/app/services/cscae.service.ts